module.exports = __webpack_public_path__ + "static/img/case-2zuozhanjiaoxue.f22169aa.jpg";